export const normalizeDate = (e : React.ChangeEvent<HTMLInputElement>) => 
{
    const value = e.target.value;

    const { nativeEvent } = e; 
    // @ts-ignore
    if (nativeEvent.inputType === 'deleteContentBackward')
    {
        if (value.length === 7 || value.length === 4)
        {
            e.target.value = e.target.value.slice(0, -1);
            return;
        }
    }

    const onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length < 4) 
    {
        e.target.value = onlyNums;
        return;
    }

    if (onlyNums.length === 4)
    {
        e.target.value = `${onlyNums}/`;
        return;
    }
    
    if (onlyNums.length < 6) 
    {
        e.target.value = `${onlyNums.slice(0, 4)}/${onlyNums.slice(4)}`;
        return;
    }

    if (onlyNums.length === 6)
    {
        e.target.value = `${onlyNums.slice(0, 4)}/${onlyNums.slice(4)}/`;
        return;
    }
    
    e.target.value = `${onlyNums.slice(0, 4)}/${onlyNums.slice(4, 6)}/${onlyNums.slice(6, 8)}`;
};

export const normalizePhone = (e : React.ChangeEvent<HTMLInputElement>) => 
{
    const value = e.target.value;

    const onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length <= 3) 
    {
        e.target.value = onlyNums;
        return;
    }
    
    if (onlyNums.length <= 7) 
    {
        e.target.value = `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3)}`;
        return;
    }
    
    e.target.value = `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export const normalizeCurrency = (e : React.ChangeEvent<HTMLInputElement>) => 
{
    const value = e.target.value;
    if (value === undefined || value === null || value === '$')
    {
        e.target.value = '';
        return;
    }
    const onlyNums = value.toString().replace(/[^\d]/g, '');

    if (onlyNums) 
    {
        e.target.value = '$' + parseInt(onlyNums).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return;
    }

    e.target.value = '';
};

export const convertCurrencyString = (value : string) : string => 
{
    return value.split(',').join('').slice(1);
};

export const normalizeCurrencyString = (value? : string | null) : string =>
{
    if (value === undefined || value === null || value === '$')
    {
        return '$0';
    }
    const onlyNums = value.toString().replace(/[^\d]/g, '');

    if (onlyNums) 
    {
        return '$' + parseInt(onlyNums).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    return '$0';
};